import React, { Component } from 'react';
import { Route, Switch, BrowserRouter } from "react-router-dom"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux"
import Homepage from  "./containers/homepage"
import Privacy from './containers/tos/privacy';
import Tos from './containers/tos/tos';

const App = () => {
  return(
    <>
     <BrowserRouter>
          <Switch>
            <Route path="/" exact component={Homepage} />
            <Route path="/privacy-policy" exact component={Privacy} />
            <Route path="/tos" exact component={Tos} />
          </Switch>
      </BrowserRouter>
    </>
  )
}

export default App